export default __webpack_public_path__ + "static/media/cs-new-user-flow.da8aea0b.png";